import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgEditorComponent } from './svg-editor/svg-editor.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgEditorComponent],
  exports: [SvgEditorComponent]
})
export class SvgModule { }
